export enum adminCompanyAllListTypes {
  FETCH_ADMIN_COMPANY_ALL_LIST_REQUEST = "FETCH_ADMIN_COMPANY_ALL_LIST_REQUEST",
  FETCH_ADMIN_COMPANY_ALL_LIST_SUCCESS = "FETCH_ADMIN_COMPANY_ALL_LIST_SUCCESS",
  FETCH_ADMIN_COMPANY_ALL_LIST_FAILURE = "FETCH_ADMIN_COMPANY_ALL_LIST_FAILURE",
}